import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import Component404 from "../Component404";
import Component500 from "../Component500";
import { setCookieData } from "../../utility/cookieHandler/handler";
import { logout } from "../../redux/reducers/auth";

const ComponentError = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  // Replace componentWillMount with useEffect
  // Note: componentWillMount is deprecated, useEffect is the correct approach
  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  const deleteCookie = () => {
    const cookieName = process.env.REACT_APP_COOKIE_NAME;
    setCookieData(cookieName, null, {
      path: "/",
      expires: new Date("Thu, 01 Jan 1970 00:00:01 GMT;"),
      domain: ".lambdatest.com"
    });
  };

  const doLogout = () => {
    deleteCookie();
    localStorage.clear();
    dispatch(logout());
    localStorage.setItem("logout-event", "logout" + Math.random());
  };

  const getContentByError = () => {
    const { pathname } = location;
    const activeSegment = pathname.split("/");
    const type = activeSegment[2];

    switch (type) {
      case "404":
        return (
          <div>
            <Component404 />
          </div>
        );
      case "500":
        return (
          <div>
            <div>
              <Component500 />
            </div>
          </div>
        );
      default:
        return (
          <div>
            <div>
              <Component404 />
            </div>
          </div>
        );
    }
  };

  return getContentByError();
};

export default ComponentError;
